export default __webpack_public_path__ + "static/media/education_pinpoint.67871428.svg";